import React from 'react';
import './PrivacyPolicy.css'; // Create styles based on the image

import CtaBanner from '../../components/CtaBanner/CtaBanner';

const PrivacyPolicy = () => {
    return (
        <div className="privacy-page">

            {/* HER SECTION */}
            <div className="privacy-hero">
                <h1>Privacy Policy</h1>
            </div>

            <div className="privacy-container">
                {/* INTRO */}
                <div className="privacy-intro">
                    <h2>Privacy Policy - Jeevan Realty</h2>
                    <p>
                        At Jeevan Realty, your privacy is our top priority. This Privacy Policy explains how we collect, use, protect,
                        and share your information when you visit our website or engage with our services. By accessing our website,
                        you agree to the practices described below.
                    </p>
                </div>

                {/* POLICY POINTS */}
                <div className="policy-list">

                    {/* 1 */}
                    <div className="policy-card">
                        <div className="policy-number">1</div>
                        <div className="policy-content">
                            <h3>Information We Collect</h3>
                            <p>We may collect the following types of information:</p>
                            <span className="policy-bullet"><strong>Personal Information:</strong> Name, email, phone number, and other details you provide through inquiry forms, registrations, or service requests.</span>
                            <span className="policy-bullet"><strong>Property Preferences:</strong> Information related to your buying, selling, or rental requirements.</span>
                        </div>
                    </div>

                    {/* 2 */}
                    <div className="policy-card">
                        <div className="policy-number">2</div>
                        <div className="policy-content">
                            <h3>How We Use Your Information</h3>
                            <p>Your data helps us provide better real estate services. We may use it for:</p>
                            <span className="policy-bullet">Responding to inquiries and scheduling property visits.</span>
                            <span className="policy-bullet">Sharing details about relevant DTCP plots, villas, and investment opportunities in Coimbatore.</span>
                            <span className="policy-bullet">Sending updates, or offers through Whatsapp</span>
                        </div>
                    </div>

                    {/* 3 */}
                    <div className="policy-card">
                        <div className="policy-number">3</div>
                        <div className="policy-content">
                            <h3>Sharing of Information</h3>
                            <p>
                                We do not sell, trade, or rent your personal information to third parties. We may share your information only with:
                            </p>
                            <span className="policy-bullet">Trusted partners and service providers who assist us in operating our website and conducting our business.</span>
                            <span className="policy-bullet">Legal authorities if required by law to protect our rights or the safety of others.</span>
                        </div>
                    </div>

                    {/* 4 */}
                    <div className="policy-card">
                        <div className="policy-number">4</div>
                        <div className="policy-content">
                            <h3>Data Security</h3>
                            <p>
                                We implement appropriate security measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, please note that no method of transmission over the internet is 100% secure.
                            </p>
                        </div>
                    </div>

                    {/* 5 */}
                    <div className="policy-card">
                        <div className="policy-number">5</div>
                        <div className="policy-content">
                            <h3>Cookies and Tracking</h3>
                            <p>
                                Our website may use cookies to enhance your user experience. Cookies help us analyze web traffic and improve our services. You can choose to accept or decline cookies through your browser settings.
                            </p>
                        </div>
                    </div>

                    {/* 6 */}
                    <div className="policy-card">
                        <div className="policy-number">6</div>
                        <div className="policy-content">
                            <h3>Third-Party Links</h3>
                            <p>
                                Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of these external sites. We encourage you to review their privacy policies before providing any personal information.
                            </p>
                        </div>
                    </div>

                    {/* 7 */}
                    <div className="policy-card">
                        <div className="policy-number">7</div>
                        <div className="policy-content">
                            <h3>Your Rights</h3>
                            <p>
                                You have the right to access, correct, or delete your personal information held by us. If you wish to update your details or opt-out of marketing communications, please contact us.
                            </p>
                        </div>
                    </div>

                    {/* 8 */}
                    <div className="policy-card">
                        <div className="policy-number">8</div>
                        <div className="policy-content">
                            <h3>Policy Updates</h3>
                            <p>
                                We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page with the revised date.
                            </p>
                        </div>
                    </div>

                    {/* CONTACT SECTION */}
                    <div className="privacy-contact">
                        <h3>Contact Us</h3>
                        <p>If you have any questions or concerns regarding this Privacy Policy, please reach out to us: Jeevan Realty - Coimbatore</p>
                    </div>

                </div>
            </div>

            {/* CTA SECTION */}
            <CtaBanner />

        </div>
    );
};

export default PrivacyPolicy;
